import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./custom.css";
import PrivateRoute from "./Components/PrivateRoute";
import Login from "./Pages/Login";
import Error from "./Pages/Error";
import AppContextProvider from "./Contexts/AppContextProvider";
import Dashboard from "./Pages/Patient/Dashboard";
import ManageAbstractors from "./Pages/Abstractor/ManageAbstractors";
import { ManageCenters } from "./Pages/Center/ManageCenters";
import ResetPassword from "./Pages/ResetPassword";
import PasswordRecovery from "./Pages/PasswordRecovery";
import { AddLocalStorageData, GetLocalStorageData } from "./Helpers/Utilities";
import packageJson from "../package.json";
import EligibilityCriteria from "./Pages/Patient/EligibilityCriteria";
import PatientScreening from "./Pages/Patient/PatientScreening";
import Demographics from "./Pages/Patient/Demographics";
import ClinicalCharacteristics from "./Pages/Patient/ClinicalCharacteristics/ClinicalCharacteristics";
import Epcoritamab from "./Pages/Patient/TreatmentAndResponse/Epcoritamab";
import TreatmentsPriorEpcoritamab from "./Pages/Patient/TreatmentAndResponse/TreatmentsPriorEpcoritamab";
import TreatmentAfterEpcoritamab from "./Pages/Patient/TreatmentAndResponse/TreatmentAfterEpcoritamab";
import CarTCellTherapy from "./Pages/Patient/TreatmentAndResponse/CarTCellTherapy";
import HRU from "./Pages/Patient/HRU";
import ValidateSubmit from "./Pages/Patient/ValidateSubmit";
const App = () => {
  const location = useLocation();

 /* <summary>
 date: 06-04-2024
 Name: AP
 description: Effect to clear the cache
 <summary>*/
    useEffect(() => {
        const Caching = () => {
            const version = GetLocalStorageData("version");
            //console.log("Package version", version);
            if (version !== packageJson.version) {
                //console.log("Clearing cache");
                AddLocalStorageData("version", packageJson.version);
                if ("caches" in window) {
                    caches.keys().then((names) => {
                        // Delete all the cache files
                        names.forEach((name) => {
                            caches.delete(name);
                        });
                    });
                }

                // Makes sure the page reloads. Changes are only visible after you refresh.
                window.location.replace(window.location.href);
            }
        };

        Caching();

        return () => { };
    }, []);

  return (
    <AppContextProvider>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Login />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/PasswordRecovery" element={<PasswordRecovery />} />
        <Route path="/" element={<PrivateRoute />}> 
          <Route path="/ManagePatients" element={<Dashboard />} />
          <Route path="/ManageAbstractors" element={<ManageAbstractors />} />
          <Route path="/ManageCenters" element={<ManageCenters />} />
          <Route path="/EligibilityCriteria" element={<EligibilityCriteria />} />
          <Route path="/PatientScreening" element={<PatientScreening />} />
          <Route path="/Demographics" element={<Demographics />} />
          <Route path="/ClinicalCharacteristics" element={<ClinicalCharacteristics />} />
          <Route path="/Epcoritamab" element={<Epcoritamab />} />
          <Route path="/TreatmentsPriorEpcoritamab/:lot" element={<TreatmentsPriorEpcoritamab />} />
          <Route path="/TreatmentsAfterEpcoritamab/:lot" element={<TreatmentAfterEpcoritamab />} />
          <Route path="/CARTCellTherapy" element={<CarTCellTherapy />} />
          <Route path="/HRU" element={<HRU />} />
          <Route path="/ValidateSubmit" element={<ValidateSubmit />} />
        </Route>
        <Route path="*" element={<Error />} />
      </Routes>
    </AppContextProvider>
  );
};
export default App;
